<template>
    <main>
        <!-- Hero section -->
        <!-- Hero section -->
        <section v-if="$i18n.locale === 'ca'">
            <div class="bg-gray-50">
                <div class="max-w-7xl mx-auto py-12 px-4 divide-y divide-gray-200 sm:px-6 lg:py-16 lg:px-8">
                    <h2 class="text-3xl font-extrabold text-gray-900">
                        Informació bàsica sobre protecció de dades i informació confidencial
                    </h2>
                    <div class="mt-8">
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Responsable</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        TICHIT<br />
                                        Plaça Nova, 10<br />
                                        C.P. 08130 - Santa Perpètua de Mogoda<br />
                                        Barcelona
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Finalitat</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Gestionar la relació que ens vincula i solucionar dubtes o consultes que ens
                                        pugui realitzar. Les dades seran conservades durant la vigència d'aquesta
                                        relació, una vegada extingida, els conservarem durant els terminis legalment
                                        exigits.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Legitimació</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Consentiment de l'interessat - Interès legítim d'ambdues parts.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">
                                    Destinataries
                                </dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        No se cediran dades a tercers, excepte obligació legal o que la comunicació
                                        sigui necessària en el marc de la relació que ens vincula.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Drets</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Té dret a sol·licitar l'accés a les seves dades personals, la seva rectificació
                                        o supressió, la limitació del seu tractament i la portabilitat de les dades a la
                                        direcció del RESPONSABLE o a través del correu electrònic
                                        <a class="text-blue-400" href="mailto:rgpd@tichit.com">rgpd@tichit.com</a>. Així
                                        mateix, té dret a presentar una reclamació davant l'Autoritat de Control/Agencia
                                        Espanyola de Protecció de Dades si considera que el tractament que realitzem de
                                        les seves dades no s'ajusta a la normativa vigent o considera que no estem
                                        atenent algun dels drets que li assisteixen i ens exerceix (<a
                                            class="text-blue-400"
                                            href="https://www.aepd.es"
                                            >www.aepd.es</a
                                        >).
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">
                                    Informació rellevant i addicional
                                </dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Aquest missatge i qualsevol annex van dirigits exclusivament al seu destinatari
                                        i pot contenir informació CONFIDENCIAL sotmesa al secret professional. Si no és
                                        el destinatari final d'aquest missatge, li preguem que: i) s'abstingui de fer ús
                                        algun de les dades de caràcter personal que poguessin constar, ii) ens ho
                                        comuniqui immediatament per aquesta mateixa via i iii) procedeixi a la seva
                                        destrucció. Queda notificat que el seu ús, distribució, impressió, còpia i
                                        difusió per qualsevol mitjà està tipificada com a delicte en l'article 197 s.s.
                                        i 278 del vigent Codi Penal.<br />
                                        Per rebre més informació respecte al tractament que realitzem de les seves
                                        dades, contacti amb nosaltres via postal o a través de correu electrònic.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="$i18n.locale === 'es'">
            <div class="bg-gray-50">
                <div class="max-w-7xl mx-auto py-12 px-4 divide-y divide-gray-200 sm:px-6 lg:py-16 lg:px-8">
                    <h2 class="text-3xl font-extrabold text-gray-900">
                        Información básica sobre protección de datos e información confidencial
                    </h2>
                    <div class="mt-8">
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Responsable</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        TICHIT<br />
                                        Plaça Nova, 10<br />
                                        C.P. 08130 - Santa Perpètua de Mogoda<br />
                                        Barcelona
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Finalidad</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Gestionar la relación que nos vincula y solventar dudas o consultas que nos
                                        pueda realizar. Los datos serán conservados durante la vigencia de dicha
                                        relación, una vez extinguida, los conservaremos durante los plazos legalmente
                                        exigidos.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">
                                    Legitimación
                                </dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Consentimiento del interesado - Interés legítimo de ambas partes.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">
                                    Destinatarios
                                </dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        No se cederán datos a terceros, salvo obligación legal o que la comunicación sea
                                        necesaria en el marco de la relación que nos vincula.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Derechos</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Tiene derecho a solicitar el acceso a sus datos personales, su rectificación o
                                        supresión, la limitación de su tratamiento y la portabilidad de los datos a la
                                        dirección del RESPONSABLE o a través del correo electrónico
                                        <a class="text-blue-400" href="mailto:rgpd@tichit.com">rgpd@tichit.com</a>.
                                        Asimismo, tiene derecho a presentar una reclamación ante la Autoridad de
                                        Control/Agencia Española de Protección de Datos si considera que el tratamiento
                                        que realizamos de sus datos no se ajusta a la normativa vigente o considera que
                                        no estamos atendiendo alguno de los derechos que le asisten y nos ejerce (<a
                                            class="text-blue-400"
                                            href="https://www.aepd.es"
                                            >www.aepd.es</a
                                        >).
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">
                                    Informacion relevante y adicional
                                </dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Este mensaje y cualquier anexo van dirigidos exclusivamente a su destinatario y
                                        puede contener información CONFIDENCIAL sometida al secreto profesional. Si no
                                        es el destinatario final de este mensaje, le rogamos que: i) se abstenga de
                                        hacer uso alguno de los datos de carácter personal que pudieran constar, ii) nos
                                        lo comunique inmediatamente por esta misma vía y iii) proceda a su destrucción.
                                        Queda notificado que su uso, distribución, impresión, copia y difusión por
                                        cualquier medio está tipificada como delito en el artículo 197 s.s. y 278 del
                                        vigente Código Penal.<br />
                                        Para recibir más información respecto al tratamiento que realizamos de sus
                                        datos, contacte con nosotros vía postal o a través de correo electrónico.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                    </div>
                </div>
            </div>
        </section>
        <section v-if="$i18n.locale === 'en'">
            <div class="bg-gray-50">
                <div class="max-w-7xl mx-auto py-12 px-4 divide-y divide-gray-200 sm:px-6 lg:py-16 lg:px-8">
                    <h2 class="text-3xl font-extrabold text-gray-900">
                        Basic information on data protection and confidential information
                    </h2>
                    <div class="mt-8">
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">
                                    Data controller
                                </dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        TICHIT<br />
                                        Plaça Nova, 10<br />
                                        C.P. 08130 - Santa Perpètua de Mogoda<br />
                                        Barcelona
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Purpose</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Manage the company-client relationship and address questions or concerns. Data
                                        will be stored during the duration of the relationship in question. Once the
                                        relationship concludes, we will save them during the legally established
                                        periods.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">
                                    Legitimation
                                </dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Interested party’s consent - Legitimate interest of both parties.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Recipients</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        Data will not be submitted to third parties, unless under a legal obligation or
                                        if the communication is necessary in the framework of the relationship in
                                        question.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">Rights</dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        You have the right to request access to your personal data to correct or delete
                                        them, limit their processing and transfer the data by addressing the DATA
                                        CONTROLLER or by e-mail at
                                        <a class="text-blue-400" href="mailto:rgpd@tichit.com">rgpd@tichit.com</a>.
                                        Likewise, you have the right to file a claim with the Spanish Data Protection
                                        Agency/Control Authority if you consider that our treatment of your data does
                                        not comply with current regulations or if you consider that we are not
                                        addressing any of the rights that you are entitled to and to which we are
                                        subject (<a class="text-blue-400" href="https://www.aepd.es">www.aepd.es</a>).
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                        <dl class="divide-y divide-gray-200">
                            <div class="pt-6 pb-8 md:grid md:grid-cols-12 md:gap-8">
                                <dt class="text-base font-medium text-gray-900 md:col-span-5 uppercase">
                                    Relevant and additional information
                                </dt>
                                <dd class="mt-2 md:mt-0 md:col-span-7">
                                    <p class="text-base text-gray-500 text-justify">
                                        This message and any attachment are addressed exclusively to the recipient and
                                        may contain CONFIDENTIAL information subject to professional secrecy. If you are
                                        not the final recipient of this message, please i) abstain from using the
                                        personal data that may appear, ii) communicate it directly by this same channel
                                        and iii) proceed to destroy it. You are hereby notified that its use,
                                        distribution, copying and sharing by any means is stipulated as a criminal
                                        offence in Article 197 and following and Article 278 of the current Criminal
                                        Code.<br />
                                        To obtain further information with regard to how we process your data, please
                                        contact us by e-mail or regular mail.
                                    </p>
                                </dd>
                            </div>

                            <!-- More questions... -->
                        </dl>
                    </div>
                </div>
            </div>
        </section>

        <!-- This example requires Tailwind CSS v2.0+ -->
        <div class="bg-white">
            <div class="max-w-7xl mx-auto text-center py-12 px-4 sm:px-6 lg:py-16 lg:px-8">
                <h2 class="text-3xl font-extrabold tracking-tight text-gray-900 sm:text-4xl">
                    <span class="block">{{ $t('marketing.section8.cta_line1') }}</span>
                    <span class="block">{{ $t('marketing.section8.cta_line2') }}</span>
                </h2>
                <div class="mt-8 flex justify-center">
                    <div class="inline-flex rounded-md shadow">
                        <a
                            target="_blank"
                            :href="
                                `mailto:info@tichit.com?body=` +
                                $t('marketing.section8.mailto_body') +
                                `&subject=` +
                                $t('marketing.section8.mailto_subject')
                            "
                            class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700"
                        >
                            <svg
                                class="w-6 h-6 mr-1"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                                xmlns="http://www.w3.org/2000/svg"
                            >
                                <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z" />
                                <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z" />
                            </svg>
                            {{ $t('marketing.section8.cta_contact_us') }}
                        </a>
                    </div>
                    <div class="ml-3 inline-flex">
                        <a
                            href="https://twitter.com/tichit_es"
                            class="inline-flex items-center justify-center px-5 py-3 border border-transparent text-base font-medium rounded-md text-indigo-700 bg-indigo-100 hover:bg-indigo-200"
                        >
                            {{ $t('marketing.section8.cta_more_info') }}
                        </a>
                    </div>
                </div>
            </div>
        </div>

        <!-- Stats section -->
        <div class="relative bg-gray-900">
            <div class="h-80 absolute bottom-0 xl:inset-0 xl:h-auto xl:grid xl:grid-cols-2">
                <div class="h-full xl:relative xl:col-start-2">
                    <img
                        class="h-full w-full object-cover opacity-25 xl:absolute xl:inset-0"
                        src="https://images.unsplash.com/photo-1521737852567-6949f3f9f2b5?ixid=MXwxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHw%3D&ixlib=rb-1.2.1&auto=format&fit=crop&w=950&q=80&sat=-100"
                        alt="People working on laptops"
                    />
                    <div
                        aria-hidden="true"
                        class="absolute inset-x-0 top-0 h-32 bg-gradient-to-b from-gray-900 xl:inset-y-0 xl:left-0 xl:h-full xl:w-32 xl:bg-gradient-to-r"
                    />
                </div>
            </div>
            <div
                class="max-w-4xl mx-auto px-4 sm:px-6 lg:max-w-7xl lg:px-8 xl:grid xl:grid-cols-2 xl:grid-flow-col-dense xl:gap-x-8"
            >
                <div class="relative pt-12 pb-64 sm:pt-24 sm:pb-64 xl:col-start-1 xl:pb-24">
                    <h2 class="text-sm font-semibold tracking-wide uppercase">
                        <span class="bg-gradient-to-r from-purple-300 to-indigo-300 bg-clip-text text-transparent">
                            {{ $t('marketing.section7.title') }}
                        </span>
                    </h2>
                    <p class="mt-3 text-3xl font-extrabold text-white">
                        {{ $t('marketing.section7.text') }}
                    </p>
                    <p class="mt-5 text-lg text-gray-300">
                        {{ $t('marketing.section7.text2') }}
                    </p>
                    <div class="mt-12 grid grid-cols-1 gap-y-12 gap-x-6 sm:grid-cols-2">
                        <p>
                            <span class="block text-2xl font-bold text-white">{{
                                $t('marketing.section7.metric1_title')
                            }}</span>
                            <span class="mt-1 block text-base text-gray-300">{{
                                $t('marketing.section7.metric1_text')
                            }}</span>
                        </p>

                        <p>
                            <span class="block text-2xl font-bold text-white">{{
                                $t('marketing.section7.metric2_title')
                            }}</span>
                            <span class="mt-1 block text-base text-gray-300">{{
                                $t('marketing.section7.metric2_text')
                            }}</span>
                        </p>

                        <p>
                            <span class="block text-2xl font-bold text-white">{{
                                $t('marketing.section7.metric3_title')
                            }}</span>
                            <span class="mt-1 block text-base text-gray-300">{{
                                $t('marketing.section7.metric3_text')
                            }}</span>
                        </p>

                        <p>
                            <span class="block text-2xl font-bold text-white">{{
                                $t('marketing.section7.metric4_title')
                            }}</span>
                            <span class="mt-1 block text-base text-gray-300">{{
                                $t('marketing.section7.metric4_text')
                            }}</span>
                        </p>
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import LandingLayout from '@/Shared/LandingLayout.vue';

export default {
    name: 'Index',
    props: {
        articles: Array,
        meta: Object,
    },
    layout: LandingLayout,
    mounted() {
        this.$i18n.locale = this.meta.locale;
    },
};
</script>
